import React from 'react';

import CopyTextInput from '@dashboard/components/form/fields/CopyTextInput';
import { CheckCircleOutline, HighlightOffOutlined, RemoveCircleOutline } from '@mui/icons-material';
import { Link as MuiLink, Stack, TableCell, TableRow, Tooltip } from '@mui/material';

type Props = {
  isPresent?: boolean;
  type: string;
  name: string;
  value: string;
  domainName: string;
};

export default function RecordRow({ type, isPresent, name, domainName, value }: Props) {
  const renderIcon = (isPresent?: boolean) => {
    if (isPresent === undefined) {
      return (
        <Tooltip title="Undefined">
          <RemoveCircleOutline fontSize="small" sx={{ color: 'grey.300' }} />
        </Tooltip>
      );
    }
    if (isPresent) {
      return (
        <Tooltip title="Verified">
          <CheckCircleOutline fontSize="small" sx={{ color: 'brand.green' }} />
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Inactive">
        <HighlightOffOutlined fontSize="small" sx={{ color: 'grey.600' }} />
      </Tooltip>
    );
  };

  const dnsLookupHref = (type: string, query: string) => {
    switch (type) {
      case 'CNAME':
        return `https://www.whatsmydns.net/dns-lookup/cname-records?server=google&query=${query}`;
      case 'TXT':
        return `https://www.whatsmydns.net/dns-lookup/txt-records?server=google&query=${query}`;
      case 'MX':
        return `https://www.whatsmydns.net/dns-lookup/mx-records?server=google&query=${query}`;
      default:
        return 'https://www.usewaypoint.com';
    }
  };

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell align="center" sx={{ paddingTop: 1.5 }}>
        {renderIcon(isPresent)}
      </TableCell>
      <TableCell>{type}</TableCell>
      <TableCell>
        <CopyTextInput value={name} />
      </TableCell>
      <TableCell>
        <CopyTextInput value={value} />
      </TableCell>
      <TableCell>
        <Stack spacing={1} direction="row">
          <MuiLink target="_blank" href={dnsLookupHref(type, name)}>
            Single
          </MuiLink>
          <MuiLink target="_blank" href={dnsLookupHref(type, `${name}.${domainName}`)}>
            Double
          </MuiLink>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
